@import "~/styles/variables";

$icon-size-s: 12px;
$icon-size-m: 15px;
$icon-size-l: 18px;

.Icon {
  color: inherit;
  display: block;
  height: $icon-size-m;
  width: $icon-size-m;

  // Sizes
  &.s {
    height: $icon-size-s;
    width: $icon-size-s;
  }

  &.l {
    height: $icon-size-l;
    width: $icon-size-l;
  }

  // Colors

  &.white {
    color: $color-white;
  }

  @each $color, $val in $colors-base {
    &.#{$color} {
      color: $val;
    }

    &.#{$color}-light {
      color: map-get($colors-light, $color);
    }

    &.#{$color}-dark {
      color: map-get($colors-dark, $color);
    }
  }

  @each $color, $val in $colors-purpose {
    &.#{$color} {
      color: $val;
    }

    &.#{$color}-light {
      color: map-get($colors-purpose-light, $color);
    }

    &.#{$color}-dark {
      color: map-get($colors-purpose-dark, $color);
    }
  }

  @each $color, $val in $font-colors {
    &.text-#{$color} {
      color: $val;
    }
  }
}
